export const GLOBAL_STATE = 'Attendance'

export const ATTENDANCE = 'ATTENDANCE' as const
export const ATTENDANCE_GROUP = 'ATTENDANCE_GROUP' as const
export const ATTENDANCE_CSV = 'ATTENDANCE_CSV' as const
export const ATTENDANCE_TABLE = 'ATTENDANCE_TABLE' as const
export const ATTENDANCE_TABLE_MODULE = 'ATTENDANCE_TABLE_MODULE' as const
export const ATTENDANCE_TABLE_STUDENT = 'ATTENDANCE_TABLE_STUDENT' as const
export const ATTENDANCE_TABLE_STUDENT_LIST = 'ATTENDANCE_TABLE_STUDENT_LIST' as const
